<template>
    <div class="container">
        <form v-on:submit.prevent="onSubmit">   
            <h1>{{'Settings' | translate}}</h1>
            <small v-if="isChanged" class="text-danger">{{'Changes have not been saved' | translate}}</small>
            <div class="form-group">    
                <label>{{'Fanpage ID' | translate}}</label>
                <input type="text" v-model="ui.fanPageID" class=form-control>
                <small class="form-text text-muted">{{'The ticket will send from this fanpage to customer. (Need further settings)' | translate}}</small>
            </div>
            <div class="form-group">    
                
                <div class="input-group">
                    <label class="input-group-text input-group-prepend">{{'Send SMS' | translate}}</label>
                    <div class="input-group-text">    
                        <input type="checkbox" v-model="ui.sendSMS" class="input-group-append ">
                    </div>
                </div>
            </div>
            <div v-if="ui.sendSMS" class="form-group">    
                <label>{{'KOTSMS' | translate}} </label>
                <div class="row">
                    <div class="col-12 col-md-6">
                        <div class="input-group">
                        <label class="input-group-text input-group-prepend">{{'Account' | translate}}</label>
                        <input type="text" v-model="ui.userName" class="form-control">
                        </div>
                    </div>
                    
                    <div class="col-12 col-md-6">
                        <div class="input-group">
                        <label class="input-group-text input-group-prepend">{{'Password' | translate}}</label>
                        <input type="text" v-model="ui.passWord" class="form-control">
                        </div>
                    </div>
                </div>    
                <small class="form-text text-muted">{{'The register sms will be sent from this KOTSMS account.' | translate}}</small>   
                <label>{{'SMS content' | translate}} </label>
                <small class="form-text text-muted">{{'Use %URL% to insert register link (without space)' | translate}}</small>   
                <textarea rows="6" v-model="ui.smsBody"  class="form-control"></textarea>
                <small class="form-text text-muted">{{$t('SMS length: {smsLength}, need {smsAmount} SMS. %URL% reserved 26 chars',{'smsLength':smsLength,'smsAmount':smsAmount})}}</small>   
            </div>
            <div class="form-group">
                    <button  @click.prevent="onSubmit" class="btn btn-primary">{{'Save' | translate}}</button>
            </div>
           
        </form>
        <app-modal 
            :options="{
                'isAlert':isAlert,
                'modalTitle':modalTitle,
                'modalText':modalText
            }" @modalEvent="onModalEvent">
        </app-modal>
    </div>
</template>
<script>
import firebase from 'firebase';
import Modal from './Modal.vue';//TODO move to mixin

export default {
    components:{//TODO move to mixin
            appModal:Modal
        },
    data(){
        return {
            ui:{
                userName:'',
                passWord:'',
                fanPageID:'',
                sendSMS:false,
                smsBody:'',
            },
            initialState:true,
            isChanged:false,
            isAlert:false,//TODO move to mixin
            modalTitle:'',//TODO move to mixin
            modalText:'',//TODO move to mixin
            currentUser:null,
            userConfig:null
        }
    },
    computed:{
        smsLength(){
            //換行算兩個，{!URL} 網址預留26個
            var str =this.ui.smsBody;
            return str.length + str.split("\n").length-1
                + (str.split("%URL%").length-1)*(26-5);
        },
        smsAmount(){
            if (this.smsLength <= 70)
                return 1;
            else
                return Math.ceil(this.smsLength/67);
        }
    },
    watch:{
        currentUser(){
            this.getUserConfig();
        },
        userConfig(){
            this.ui.fanPageID = this.userConfig.fanPageID?this.userConfig.fanPageID:'';
            this.ui.userName = this.userConfig.KOTSMS.userName?this.userConfig.KOTSMS.userName:'';
            this.ui.passWord = this.userConfig.KOTSMS.passWord?this.userConfig.KOTSMS.passWord:'';
            this.ui.sendSMS = this.userConfig.sendSMS?this.userConfig.sendSMS:'';
            this.ui.smsBody = this.userConfig.smsBody?this.userConfig.smsBody:'';
        },
        ui:{
            handler(){
                if(this.initialState){
                    this.initialState = false;
                }else{
                    this.isChanged=true;
                }
                    
            },
            deep:true

        }

    },
    methods:{
        onSubmit(){
            var self = this;
            this.updateUserConfig()
            .then((result)=>{
                if(result){
                    self.modalAlert(self.$t('Settings'),self.$t('Saved Successfully!'));
                    self.isChanged = false;
                    self.initialState = false;
                }
                    

            })
            .catch((error)=>{
                self.modalAlert(self.$t('Settings'),self.$t('Saved Failed')+ error);
            });
            
        },
        updateUserConfig(){//Warning: massive duplicate code
                console.log('Updating User Config...');
                var databaseRef = firebase.database().ref('users/' + this.currentUser.uid + '/config');
                var self =this;
                var updates ={};
                updates['fanPageID'] = this.ui.fanPageID;
                updates['smsBody'] = this.ui.smsBody;
                updates['sendSMS'] = this.ui.sendSMS;
                updates['smsAmount'] = this.smsAmount;
                updates['KOTSMS/userName'] = this.ui.userName;
                updates['KOTSMS/passWord'] = this.ui.passWord;

                return new Promise((resolve, reject) => { 
                    databaseRef.update(updates, function(error) {
                        if (error) {
                            console.log("Updating User Config failed...");
                            reject(error);
                        } else {
                            console.log("Updating User Config success!");
                            resolve(true);
                            
                        }
                    });
                });
        },
        getCurrentUser(){//Warning: massive duplicate code
                var self =this;
                firebase.auth().onAuthStateChanged(function(user) {
                    if (user) {
                        self.currentUser = user;
                    } else {
                        console.log('No user has signed in.');
                    }
                })
        },
        getUserConfig(){//Warning massive duplicate code
            console.log('Fetching User Config');
            var databaseRef = firebase.database().ref('users/' + this.currentUser.uid + '/config');
            var self = this;
            databaseRef.once('value')
                .then(function(snapshot) {
                    
                    if(snapshot!=null){
                        console.log('Loaded User config');
                        self.userConfig = snapshot.val();
                        
                    }else{
                        console.log('User config not exists');
                        
                    }
                    
                },function(error){
                    console.log('Loading User config  error: ' + error);

                });

        },
        modalAlert(title,text){//TODO move to mixin
                this.modalTitle = title;
                this.modalText = text;
                this.isAlert = true;
        },
        onModalEvent(event){//TODO move to mixin
                console.log(event);
                this.isAlert = false;
                this.modalTitle = '';
                this.modalText = '';
        },
    },
    mounted(){
        this.getCurrentUser();

    }
    
}
</script>
